import { Grid } from '@mui/material'
import { makeStyles } from '@mui/styles'
import React from 'react'
import { useSelector } from 'react-redux'
import { campaignSlice } from '../../reducers'
import { ExploreMenuCampaignBanner } from '../campaign/explore-menu-banner'
import Header from './header'
import HumanMadeBanner from '../human-made-banner'
import { useFormFactor } from '../../hooks'

export const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  columns: {
    marginRight: spacing(6),
    marginBottom: spacing(2)
  }
}))

const Layout = ({
  title,
  groupCategorySelected = {},
  onClose,
  panel1,
  panel2,
  panel3,
  panelCtnLgSize = 8,
  panel1LgSize = 6,
  panel2LgSize = 6,
  panel3LgSize = 4,
  bannerLgSize = 12,
  showBannerRight
}) => {
  const classes = useStyles()
  const campaign = useSelector(campaignSlice.selectors.campaignData)
  const { isDesktop } = useFormFactor()
  return (
    <Grid container spacing={2}>
      <Grid container item xs={12}>
        <Header title={title} onClose={onClose} groupCategorySelected={groupCategorySelected} />
      </Grid>
      <Grid container item spacing={4} className={classes.columns}>
        <Grid item xs={12} lg={panelCtnLgSize}>
          {/* Inner container owns the panel gutter (spacing={4}). Keeping it
              separate from the sizing item avoids the container+item+spacing
              nesting that double-applies MUI's negative margins and overflows
              the column. */}
          <Grid container spacing={4}>
            {panel1 && (
              <Grid item xs={12} lg={panel1LgSize}>
                {panel1}
              </Grid>
            )}
            {panel2 && (
              <Grid item xs={12} lg={panel2LgSize}>
                {panel2}
                {showBannerRight && <ExploreMenuCampaignBanner campaign={campaign} />}
              </Grid>
            )}
            {/* Gate the slot itself, not just its contents: the banner renders
                null without a campaign (and is desktop-only), so an always-on
                Grid item left a full spacing={4} gutter of dead space above
                whatever follows. */}
            {!showBannerRight && isDesktop && campaign && (
              <Grid item xs={12} lg={bannerLgSize}>
                <ExploreMenuCampaignBanner campaign={campaign} />
              </Grid>
            )}
            {/* Full-width strip under the panel columns — closes the left
                column group, clear of the narrower third panel. It lives here
                rather than in a `footer` slot so every menu view carries it:
                drilling from Discover into a category re-renders the menu as
                CategoryView, which would otherwise drop the badge.
                Unlike the campaign banner above, this one is not conditional —
                it renders on every view and form factor. The grid gutter
                already separates it from the panels, so it drops its own top
                margin rather than stacking on it. */}
            <Grid item xs={12}>
              <HumanMadeBanner
                dataTest='explore-menu-human-made-banner'
                disableTopSpacing
              />
            </Grid>
          </Grid>
        </Grid>
        {panel3 && (
          <Grid item xs={12} lg={panel3LgSize}>
            {panel3}
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default Layout
